<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500" :persistent="creatingInvoice" @input="val => { if (!val) dialogclose() }">
      <div v-if="!creatingInvoice" @click="dialogclose()" class="close">
        <Icon name="close" />
      </div>
      <v-card v-if="creatingInvoice" class="wrapper invoice_loading" role="status" aria-live="polite">
        <v-progress-circular indeterminate color="#4B5EFF" :size="48" />
        <div class="modal_title">Выставляем счёт</div>
      </v-card>
      <v-card class="wrapper" v-if="complete && !criticalError">
        <div class="modal_title">Спасибо!</div>
        <div class="input_wrapper">Пожалуйста дождитесь проверки платежа.</div>
      </v-card>
      <v-card class="wrapper" v-if="criticalError">
        <div class="modal_title">
          Для пополнения баланса свяжитесь пожалуйста с нами:<br />
          +7 (495) 032-00-09<br />
          help@crmcalls.ru
        </div>
      </v-card>
      <v-card class="wrapper" v-if="!complete && !creatingInvoice">
        <div class="modal_title">Пополнение баланса</div>
        <v-tabs v-model="payType" grow>
          <v-tab key="card">Банковской картой</v-tab>
          <v-tab key="invoice">Счёт на оплату</v-tab>
        </v-tabs>
        <v-tabs-items v-model="payType">
          <v-tab-item key="card">
            <div class="input_wrapper">
              <div class="label">Сумма</div>
              <v-text-field
                v-model="summ"
                placeholder="10000₽"
                type="number"
              ></v-text-field>
            </div>
            <p style="color: red" v-if="valErrorZero">
              Введите сумму пополнения
            </p>
            <p style="color: red" v-if="minSum1000">
              Минимальная сумма для пополнения - 1 000 рублей
            </p>
            <p style="color: red" v-if="minSum10000">
              Минимальная сумма для пополнения - 15 000 рублей
            </p>
            <!-- <p style="color:red;" v-if="valError && this.summ !== 0 && this.summ < minSum">Минимальная сумма для пополнения - 10 000 рублей</p> -->
            <p style="color: red" v-if="valErrorDoc">
              Подтвердите согласие с условиями Лицензии
            </p>
            <div class="check_policy">
              <v-checkbox v-model="check_oferta"></v-checkbox>
              <div class="check_policy_text">
                Подтверждаю своё согласие с условиями
                <a
                  target="_blank"
                  color="#4B5EFF"
                  :href="`https://${$baseDomain}/liczenziya/`"
                  >Лицензии</a
                >
                <!--				Я даю <a target="_blank" :href="`https://${$baseDomain}/wp-content/themes/crmcalls/assets/assets/pdf/soglasie.pdf`">согласие</a> на получение рекламно-информационных материалов от CRMCalls-->
              </div>
            </div>
            <div @click="makeBill()" class="my_btn add_modal">Пополнить</div>
            <div class="my_btn" @click="dialogclose()">Отменить</div>
          </v-tab-item>
          <v-tab-item key="invoice">
            <div class="input_wrapper">
              <div class="label">Организация-плательщик</div>
              <v-text-field
                :value="companyInfo"
                disabled
                filled
                readonly
                outlined
              />
              <p v-if="companyError" style="color: red">Необходимо подтвердить реквизиты организации пожалуйста, обратитесь в поддержку</p>
            </div>
            <div class="input_wrapper">
              <div class="label">Сумма</div>
              <v-text-field
                v-model="summ"
                placeholder="1000₽"
                type="number"
                outlined
              />
            </div>
            <p v-if="!(Number(summ) > invoiceMinSum)" style="color: red">
              Минимальная сумма для пополнения — {{ invoiceMinSum.toLocaleString('ru-RU') }} рублей
            </p>
            <div class="check_policy">
              <v-checkbox v-model="check_oferta"></v-checkbox>
              <div class="check_policy_text">
                Подтверждаю своё согласие с условиями
                <a
                  target="_blank"
                  color="#4B5EFF"
                  :href="`https://${$baseDomain}/liczenziya/`"
                  >Лицензии</a
                >
              </div>
            </div>
            <p v-if="invoiceError" role="alert" style="color: red">
              {{ invoiceError }}
            </p>
            <div @click="createInvoice()" class="my_btn add_modal">
              Выставить счёт
            </div>
            <div class="my_btn" @click="dialogclose()">Отменить</div>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Icon from '../../SetIcon.vue';
export default {
  components: {
    Icon,
  },
  props: [
    'title',
    'btn',
    'dialogstate',
    'dialogclose',
    'opensuccess',
    'updatetable',
  ],
  data() {
    return {
      companyError: false,
      dialog: this.dialogstate,
      summ: 0,
      minSumFirst: 15000,
      minSumSecond: 1000,
      invoiceMinSum: 1000,
      complete: false,
      criticalError: false,
      valError: false,
      valErrorDoc: false,
      valErrorZero: false,
      check_oferta: false,
      minSum1000: false,
      minSum10000: false,
      payType: 0,
      invoiceComplete: false,
      invoiceNumber: '',
      invoiceError: '',
      creatingInvoice: false,
      companyInfo: '',
      hasCompanyData: false,
    };
  },
  methods: {
    async loadCompanyData() {
      this.companyInfo =
        'Загрузка данных... ' + new Date().toLocaleTimeString();

      try {
        const response = await this.$http.get('billing/invoice-data');

        if (!response || !response.data) {
          this.companyInfo = 'Ошибка: пустой ответ от сервера';
          return;
        }

        if (response.data.ok) {
          const company = response.data.company;
          this.hasCompanyData = response.data.hasCompanyData;
          this.companyError = false

          if (company && company.name && company.inn) {
            this.companyInfo = `${company.name}, ИНН ${company.inn}`;
          } else if (company && company.inn) {
            this.companyInfo = `ИНН ${company.inn}`;
            this.companyError = true
          } else if (company && company.name) {
            this.companyInfo = `${company.name}`;
            this.companyError = true
          } else {
            this.companyInfo = 'Данные не заполнены';
            this.companyError = true
          }
        } else {
          this.companyInfo = 'Ошибка: ' + response.data.message;
        }
      } catch (error) {
        this.companyInfo = 'Исключение: ' + error.message;
        this.companyError = true
      }
    },
    async openInvoicePdf(url) {
      try {
        const token = sessionStorage.getItem('token');
        const sep = url.includes('?') ? '&' : '?';
        const res = await fetch(
          `${url}${sep}token=${encodeURIComponent(token)}`,
        );

        if (!res.ok) throw new Error('HTTP error');

        const blob = await res.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = 'invoice.pdf';
        a.click();

        setTimeout(() => URL.revokeObjectURL(blobUrl), 60_000);
        return true;
      } catch (e) {
        console.error('Ошибка скачивания счёта:', e);
        this.invoiceError = 'Произошла непредвиденная ошибка. Попробуйте позже.';
        return false;
      }
    },
    createInvoice() {
      if (this.creatingInvoice) return;

      if (Number(this.summ) < this.invoiceMinSum) {
        this.invoiceError = `Минимальная сумма ${this.invoiceMinSum.toLocaleString('ru-RU')} рублей`;
        return;
      }

      if (!this.check_oferta) {
        this.invoiceError = 'Подтвердите согласие с Лицензией';
        return;
      }

      if (!this.hasCompanyData) {
        this.invoiceError = 'Заполните данные организации в профиле';
        return;
      }

      this.creatingInvoice = true;
      this.invoiceError = '';

      this.$http.post(
        '/billing/create-invoice',
        {
          summ: this.summ,
        },
        async (result) => {
          try {
            if (result && result.ok && result.invoice && result.invoice.pdf_url) {
              const downloaded = await this.openInvoicePdf(result.invoice.pdf_url);
              if (downloaded) this.dialogclose();
            } else {
              this.invoiceError = 'Произошла непредвиденная ошибка. Попробуйте позже.';
            }
          } finally {
            this.creatingInvoice = false;
          }
        },
      );
    },
    closeInvoice() {
      this.invoiceComplete = false;
      this.dialogclose();
    },
    sendForm() {
      let _this = this;
      if (this.summ != 0 && this.summ) {
        //_this.dialogclose()
        // this.$store.commit('user/setPayments', result)
        if (_this.updatetable) _this.updatetable();
        this.$http.post(
          '/cabinet/set_balance',
          {
            summ: this.summ,
          },
          (result) => {
            if (result) {
              //_this.dialogclose()
              this.complete = true;
              this.$store.commit('user/setPayments', result);
              if (_this.updatetable) _this.updatetable();
            } else {
              alert('Ошибка сервера');
            }
          },
        );
      } else this.valError = true;
    },
    makeBill() {
      if (
        (this.minSum10000 &&
          this.summ >= this.minSumFirst &&
          this.check_oferta) ||
        (this.minSum1000 && this.summ >= this.minSumSecond && this.check_oferta)
      ) {
        this.valErrorZero = false;
        this.valError = false;
        this.$http.post(
          '/cabinet/make_bill',
          {
            summ: this.summ,
          },
          (result) => {
            if (result) {
              window.open(result, '_blank');
              this.dialogclose();
            } else {
              alert('Произошла ошибка при пополнении баланса');
              this.complete = true;
              this.criticalError = true;
            }
          },
        );
      } else {
        if (this.summ === 0) {
          this.valErrorZero = true;
        } else if (this.summ < this.minSum) {
          this.valError = true;
        } else {
          this.valError = false;
          this.valErrorZero = false;
        }
        if (!this.check_oferta) {
          this.valErrorDoc = true;
        } else {
          this.valErrorDoc = false;
        }
      }
    },
  },

  watch: {
    dialogstate(nowValue) {
      this.dialog = nowValue;
      this.$http.post('/cabinet/check_min_sum', {}, (result) => {
        if (result) {
          this.minSum1000 = true;
          this.invoiceMinSum = 1000;
        } else {
          this.minSum10000 = true;
          this.invoiceMinSum = 15000;
        }
      });

      if (nowValue) {
        this.$nextTick(() => {
          if (this.payType === 1) {
            this.loadCompanyData();
          }
        });
      }
    },
    payType(newVal) {
      if (newVal === 1) {
        this.loadCompanyData();
      }
    },
  },
};
</script>
<style scoped>
.invoice_loading {
  min-height: 220px;
  justify-content: center;
}
.input_wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.label {
  text-align: left;
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  color: #404247;
  margin-bottom: 6px;
}
.wrapper {
  padding: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.input_wrapper:first-of-type {
  margin-top: 30px;
}
.my_btn {
  text-transform: none;
  border: none;
  background: none;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 120%;
  color: #4b5eff;
  cursor: pointer;
}
.add_modal {
  border: none;
  width: 100%;
  padding: 12px 20px 12px 22px;
  background: #4b5eff !important;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  line-height: 120%;
  justify-content: center;
  color: #ebebeb;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-style: normal;
}
.modal_title {
  padding: 0 !important;
  font-style: normal;
  font-weight: 800;
  font-size: 24px;
  margin-top: 19px;
  margin-bottom: 24px;
  text-align: center;
  line-height: 130%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #2b2d33;
}

.check_policy {
  display: flex;
  margin-left: 8px;
}

.check_policy_text {
  text-align: left;
  font-size: 15px;
  margin-bottom: 15px;
}
::v-deep .v-tabs-slider {
  background-color: #4b5eff;
}
::v-deep .v-tab {
  color: #2b2d33 !important;
}
</style>
